import React from "react";
import { CheckCircle } from "lucide-react";
import { cn } from "../../lib/utils";

interface BulletListProps {
  items: React.ReactNode[];
  color?: "default" | "muted";
  marker?: "disc" | "check" | "dash";
  className?: string;
}

const colorStyles = {
  default: "text-gray-700",
  muted: "text-gray-500",
};

export const BulletList: React.FC<BulletListProps> = ({
  items,
  color = "default",
  marker = "disc",
  className,
}) => {
  if (marker === "check") {
    return (
      <ul className={cn("space-y-3", colorStyles[color], className)}>
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-3">
            <CheckCircle className="w-5 h-5 text-cambridge mt-0.5 flex-shrink-0" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    );
  }

  if (marker === "dash") {
    return (
      <ul className={cn("space-y-2", colorStyles[color], className)}>
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-2">
            <span className="text-gray-400 flex-shrink-0">&mdash;</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    );
  }

  return (
    <ul className={cn("list-disc pl-6 space-y-2", colorStyles[color], className)}>
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  );
};
